import { render, staticRenderFns } from "./BackAndForthFooter2.vue?vue&type=template&id=6f44b880&scoped=true"
import script from "./BackAndForthFooter2.vue?vue&type=script&lang=ts"
export * from "./BackAndForthFooter2.vue?vue&type=script&lang=ts"
import style0 from "./BackAndForthFooter2.vue?vue&type=style&index=0&id=6f44b880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f44b880",
  null
  
)

export default component.exports